type CurrencyType = '₹' | '$' | '€';

export const currency: CurrencyType = '$';

export const currentYear = new Date().getFullYear();

export const developedByLink = 'https://techzaa.getappui.com/';

export const developedBy = 'Techzaa';

export const contactUs = 'techzaastudio@gmail.com';

export const buyLink = '';

export const basePath = '';

export const cookieName = 'access_token';

export const default_page_size = 8;

export const DEFAULT_PAGE_TITLE = 'CLB Bơi Thủ Đô';

// Replace the URL's value in env with your backend's URL or if you're using nextjs's API, add the server's origin URL
export const API_BASE_PATH = '';

export const colorVariants = [
  'primary',
  'secondary',
  'success',
  'danger',
  'warning',
  'info',
  'dark',
  'purple',
  'pink',
  'orange',
  'light',
  'link',
];
